angular.module('lodash', [])
    .factory('_', ['$window', function ($window) {
        return $window._;
    }]);
angular
    .module('templates', []);
angular
    .module('application', [
    'ngAnimate',
    'ngAria',
    'ngMaterial',
    'templates',
    'lodash',
    'ngStorage',
    'btford.socket-io',
    'ui.router',
    'ui.router.stateHelper',
    'datatables',
    'datatables.ibmTheme',
    'ngFileUpload',
    'ngSanitize',
    'angularMoment',
]);
var HttpProvider = (function () {
    function HttpProvider($httpProvider) {
        this.$httpProvider = $httpProvider;
        $httpProvider.defaults.useXDomain = true;
        // delete $httpProvider.defaults.headers.common['X-Requested-With'];
        $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    }
    HttpProvider.$inject = ['$httpProvider'];
    return HttpProvider;
}());
angular
    .module('application')
    .config(['$httpProvider', HttpProvider]);
var CompileProvider = (function () {
    function CompileProvider($compileProvider) {
        this.$compileProvider = $compileProvider;
        $compileProvider.debugInfoEnabled(false);
    }
    CompileProvider.$inject = ['$compileProvider'];
    return CompileProvider;
}());
angular
    .module('application')
    .config(['$compileProvider', CompileProvider]);
/*
class MdAriaProvider {
    static $inject = ['$mdAriaProvider'];
    constructor(private $mdAriaProvider: any) {
        $mdAriaProvider.disableWarnings();
    }
}

angular
    .module('application')
    .config(['$mdAriaProvider', MdAriaProvider]);
*/
var LocationProvider = (function () {
    function LocationProvider($locationProvider) {
        this.$locationProvider = $locationProvider;
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false,
            rewriteLinks: false
        });
    }
    LocationProvider.$inject = ['$locationProvider'];
    return LocationProvider;
}());
angular
    .module('application')
    .config(['$locationProvider', LocationProvider]);
var MdIconProvider = (function () {
    function MdIconProvider($mdIconProvider) {
        this.$mdIconProvider = $mdIconProvider;
        $mdIconProvider
            .icon('more', '/static/img/icons/ic_more_vert_24px.svg', 24)
            .icon('close', '/static/img/icons/ic_close_24px.svg', 24);
    }
    MdIconProvider.$inject = ['$mdIconProvider'];
    return MdIconProvider;
}());
angular
    .module('application')
    .config(['$mdIconProvider', MdIconProvider]);
var MdThemingProvider = (function () {
    function MdThemingProvider($mdThemingProvider) {
        this.$mdThemingProvider = $mdThemingProvider;
        //        $mdThemingProvider;
        $mdThemingProvider.theme('red');
        $mdThemingProvider.theme('green');
    }
    MdThemingProvider.$inject = ['$mdThemingProvider'];
    return MdThemingProvider;
}());
angular
    .module('application')
    .config(['$mdThemingProvider', MdThemingProvider]);
var Run = (function () {
    function Run($rootScope, $state, env, $window, $location, $http, $localStorage, $login, socket) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.env = env;
        this.$window = $window;
        this.$location = $location;
        this.$http = $http;
        this.$localStorage = $localStorage;
        this.$login = $login;
        this.socket = socket;
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            //If redirected to a dead end page, ie: not auth'd etc
            var deadEnds = ['500', '400', '403', 'terms'];
            if (deadEnds.indexOf(toState.name) > -1) {
                return;
            }
            if (toState.authenticate && !this.env.user.loggedIn) {
                console.info('$init.ts => Not logged in...routing to home');
                this.$window.location.href = '/';
            }
            else if ((toState.authenticate && !this.env.user.allowed) ||
                (this.env.user.loggedIn && !this.env.user.allowed)) {
                // User authenticated but not in any Blue Groups
                $state.transitionTo('500');
                event.preventDefault();
                return;
            }
            else if (this.env.user.loggedIn && this.env.user.allowed) {
                // If the user has not confirmed the latest terms (defined server-side)...redirect to enforce it
                if (!this.env.user.termsOk) {
                    $state.transitionTo('terms');
                    event.preventDefault();
                    return;
                }
                //Authenticated AND in Blue Groups
                //                if (toState.name ==='admin' && !this.env.user.access.systemAdmin) {
                if (toState.name.indexOf('admin.') > -1
                    && (toState.name.indexOf('mysa-dmt-view') < 0 || toState.name.indexOf('mysa-im-outbound-view') < 0) && !this.env.user.access.systemAdmin) {
                    //If user attempts to access Admin pages but is not system admin
                    $state.transitionTo('noadmin');
                    event.preventDefault();
                    return;
                }
                else if (toState.name === 'home') {
                    /* User is authenticated and doesn't ask anything else */
                    //Home for BPSO Admin or Non-BPSO Admin is myqueue...everyone else is teamqueue
                    var homeQueue = 'teamqueue';
                    if (env.user.access.bpsoAdmin || env.user.access.nonBpsoAdmin) {
                        homeQueue = 'myqueue';
                    }
                    $state.transitionTo('queue', {
                        id: homeQueue
                    });
                    event.preventDefault();
                }
                else if (toState.name === 'approvals' && !this.env.user.approver) {
                    /* User is authenticated and doesn't ask anything else */
                    $state.transitionTo('noapprover');
                    event.preventDefault();
                    return;
                }
            }
        });
    }
    Run.$inject = ['$rootScope', '$state', 'env', '$window', '$location', '$http', '$localStorage', '$login', 'socket'];
    return Run;
}());
angular
    .module('application')
    .run(Run);

//# sourceMappingURL=init.js.map
